<template>
    <div class="page-container">
        <div class="page-wrapper">
            <div class="page-top">
                <img src="../../assets/withdraw-succ.png" alt="" class="withdraw-succ">
                <div class="top-text">提现申请成功</div>
            </div>
            <div class="page-bottom">
                <div class="item">
                    <span>收款账户</span>
                    <span>{{accountName}}</span>
                </div>
                <div class="item">
                    <span>账户号</span>
                    <span>{{accountNo}}</span>
                </div>
                <div class="item">
                    <span>提现金额</span>
                    <span>{{amount}}元</span>
                </div>
                <div class="item">
                    <span>提现时间</span>
                    <span>{{withdrawTime}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            accountName:'',
            accountNo:'',
            amount:0,
            withdrawTime:'',
        }
    },
    created(){
        let parm=this.$route.params;
        
        this.accountName=parm.accountName;
        this.accountNo=parm.accountNo;
        this.amount=parm.amount;
        this.withdrawTime=parm.withdrawTime;
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    background:#f5f5f5;
    min-height: calc(100vh - 46px);
    box-sizing: border-box;
    padding:20px;
    .page-wrapper{
        background:#fff;
        box-shadow: 0px 2px 15px 0px rgba(220, 220, 220, 0.5);
        .page-top{
            text-align: center;
            overflow: hidden;
            border-bottom: 1px dashed #dcdcdc;
            .withdraw-succ{
                width:80px;
                height:80px;
                margin-top: 35px;
                margin-bottom: 17px;
            }
            .top-text{
                color:#333;
                font-size: 18px;
                line-height: 25px;
                font-weight: 500;
                text-shadow: 0px 2px 15px rgba(220, 220, 220, 0.5);
                margin-bottom: 43px;
            }
        }
        .page-bottom{
            padding:28px 20px;
            position: relative;
            z-index: 1;
            &::before,&::after{
                content:'';
                display: block;
                width:26px;
                height:26px;
                border-radius: 50%;
                background: #f5f5f5;
                position: absolute;
                top:-13px;
                z-index: 2;
            }
            &::before{
                left:-13px;
            }
            &::after{
                right:-13px;
            }
            .item{
                @include flex-between();
                margin-bottom: 10px;
                &:last-child{
                    margin-bottom: 0;
                }
                &>span{
                    font-size: 14px;
                    &:first-child{
                        color:#333;
                    }
                    &:last-child{
                        font-size: #666;
                    }
                }
            }
        }
    }
}
</style>